<template>
  <div class="table-responsive" :class="{ 'tbl-inherit': overflowState }">
    <div class="row">
      <div class="col-sm-3">
        <Alert type="danger" :messages="errors" />
      </div>
    </div>
    <div style="width: 100%; overflow-x: visible;">
      <table class="table" v-show="!loading">
        <thead>
          <tr>
            <th class="" style="width: 20px!important;">
              <!--<span @click="checkAll()" style="cursor:pointer;">全て選択</span>-->
              <input type="checkbox"  v-model="isCheckAll" @click="checkAll()"  style="width: 18px;height: 18px;margin-left: 5px;"/>
            </th>
            <th></th>
            <template>
              <th
                v-on:click="sorting('scoutedAt')"
                class="text-center arrow-link"
                style="min-width: 100px !important; max-width: 100px !important;"
              >
                スカウト希望日
                <i
                  class="fa fa-long-arrow-up"
                  :class="{ active: sortBy == 'scoutedAt' }"
                  aria-hidden="true"
                ></i>
                <i
                  class="fa fa-long-arrow-down"
                  :class="{ active: sortBy == '-scoutedAt' }"
                  aria-hidden="true"
                ></i>
              </th>
              
              <th class="text-center" style="width: 300px;">スカウト希望求人</th>

              <th class="text-center arrow-link">
                登録者情報
              </th>
              <th class="text-center arrow-link">
                メモ
              </th>
            </template>

            <th class="text-center">
              <!-- <span v-show="!isReviewer">登録者ステータス</span> -->
              <b-dropdown
                ref="statusDropdown"
                id="ddown-aria"
                text="登録者ステータス"
                variant="primary"
                class="m-2 th-dropdown"
                @hidden="resetStatusSelection"
                @shown="overflow"
              >
                <div>
                  <div
                    class="form-check form-check"
                    v-for="(status, index) in clientStatus"
                    v-bind:key="index"
                  >
                    <input
                      type="checkbox"
                      :id="index"
                      :value="status"
                      class="form-check-input"
                      v-model="tempStatusModel"
                    />
                    <label class="form-check-label">{{ status }}</label>
                  </div>
                  <div class="dropdown-separator"></div>
                  <div class="dropdown-footer">
                    <button class="btn-sm btn-primary ok-button" @click="applyStatusFilters">
                      OK
                    </button>
                  </div>
                </div>
              </b-dropdown>
            </th>
            <th class="text-center">スカウト実施</th>
            <th class="text-center">スカウト日</th>
            <th class="text-center" style="width: 150px;">スカウト求人</th>
          </tr>
        </thead>
        <tbody>
          <ScoutApplicantsRow
            v-for="(applicant, index) in applicants"
            v-bind:key="applicant.id + index"
            :applicant="applicant"
            :applicantIndex="index"
            :rowNumber="rowNumber(index)"
            @hidden="overflowState = 0"
            @shown="overflow"
            @changed="checkUncheckJobseeker"
          />
          <tr v-if="showEmptyMessage">
            <td colspan="100%" class="text-center">
              登録者が見つかりませんでした
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="pagination-area" v-if="totalPages > 1">
      <paginate :total-page="totalPages" :callback="changePage" />
    </div>
    <Loader v-show="loading" />
  </div>
</template>

<script>
/* eslint-disable */

// Components
import ScoutApplicantsRow from './ScoutApplicantsRow.vue';
import Loader from '@/components/utils/Loader.vue';
import Paginate from '@/components/utils/Paginate.vue';
import Alert from '@/components/utils/Alert.vue';

// Vuex
import { mapMutations, mapActions, mapState, mapGetters } from 'vuex';

// Config & Services
import actions from '@/config/actions';
import mutations from '@/config/mutations';
import Api from '@/config/api';
import ApiService from '@/service/apiService';

export default {
  name: 'ScoutApplicantsList',

  components: { Paginate, Loader, ScoutApplicantsRow, Alert },
  data() {
    return {
      // childJobModel: [],
      // loading: true,
      // pagination: {},
      sortKey: null,
      asc: true,
      // mainJobModel: [],
      overflowState: 0,
      errors: [],
      // isCheckAll: false,
      // jobseekerIds: [],
      perPageRows: ['20件', '50件'],
      selectedLabel: '',
      tempStatusModel: [],
      showEmptyMessage: false,
    };
  },
  async created() {
    try {
      // if (this.mainJobModel.length > 0) {
      //   consoel.log('here');
      //   this.mainJobModelChanged(this.mainJobModel);
      //   this.search();
      // }
      await this.load(this.buildParams(1));
      // else{
      //   console.log('called');
      //   this.load(this.buildParams(1));
      // }

      // if (this.mainJobModel.length === 0) {
      //   await this.load(this.buildParams(1));
      // }
      this.loadMenuConfigurations();
    } catch (error) {
      // Handle any errors that might occur during the creation process
      console.error(error);
    }
  },
  computed: {
    ...mapGetters({
      getChildJobModel: 'getChildJobModel',
      getMainJobModel: 'getMainJobModel',
      getEnglishSkillModel: 'getEnglishSkillModel',
      getStatusModel: 'getStatusModel',
      clientStatus: 'getClientStatus',
      getColorModel: 'getColorModel',
      getClientColor: 'getClientColor',
      getCompanyModel: 'getCompanyModel',
      getMenus: 'getMenus',
      reviewLists: 'getReviewLists',
      isAdmin: 'currentUserIsAdmin',
      isReviewer: 'isCreateReviewUser',
      getReviewListModel: 'getReviewListModel',
      defaultLoaded: 'getDefaultLoaded',
      getScoutType: 'getScoutType',
      getScoutTypeModel: 'getScoutTypeModel',
      // scoutedBy: 'getScoutedBy',
    }),
    ...mapState({
      applicants: ({ applicant }) => applicant.applicants,
      reloadApplicants: ({ applicant }) => applicant.reloadApplicants,
      applicantStatusToFilter: ({ applicant }) =>
        applicant.applicantStatusToFilter,
      loading: ({ applicant }) => applicant.loading,
      isCheckAll: ({ applicant }) => applicant.isCheckAll,
      jobseekerIds: ({ applicant }) => applicant.jobseekerIds,
      activeCategory: ({ applicant }) => applicant.activeCategory,
      favoritesOnly: ({ applicant }) => applicant.favoritesOnly,
      scoutOnly: ({ applicant }) => applicant.scoutOnly,
      scoutedBy: ({ applicant }) => applicant.scoutedBy,
      interviewsOnly: ({ applicant }) => applicant.interviewsOnly,
      searchParams: ({ applicant }) => applicant.scoutSearchParams,
      sortBy: ({ applicant }) => applicant.sortBy,
      page: ({ applicant }) => applicant.page,
      pagination: ({ applicant }) => applicant.pagination,
      occupations: ({ applicant }) => applicant.selectors.occupations || [],
      englishSkills: ({ applicant }) => applicant.selectors.englishSkills || [],
    }),
    reviewListModel: {
      get() {
        return this.getReviewListModel;
      },
      set(value) {
        this.setReviewListModel(value);
      },
    },
    mainJobModel: {
      get() {
        return this.getMainJobModel;
      },
      set(value) {
        this.setMainJobModel(value);
      },
    },
    childJobModel: {
      get() {
        return this.getChildJobModel;
      },
      set(value) {
        this.setChildJobModel(value);
      },
    },
    englishSkillModel: {
      get() {
        return this.getEnglishSkillModel;
      },
      set(value) {
        this.setEnglishSkillModel(value);
      },
    },
    statusModel: {
      get() {
        return this.getStatusModel;
      },
      set(value) {
        this.setStatusModel(value);
      },
    },
    scoutTypeModel: {
      get() {
        return this.getScoutTypeModel;
      },
      set(value) {
        this.setScoutTypeModel(value);
      },
    },
    colorModel: {
      get() {
        return this.getColorModel;
      },
      set(value) {
        this.setColorModel(value);
      },
    },
    companyModel: {
      get() {
        return this.getCompanyModel;
      },
      set(value) {
        this.setCompanyModel(value);
      },
    },
    totalPages() {
      const { pagination } = this;
      return pagination.total
        ? Math.ceil(pagination.total / pagination.perPage)
        : 0;
    },
    from() {
      return (
        (parseInt(this.pagination.current, 10) - 1) * this.pagination.perPage +
        1
      );
    },
    to() {
      return (
        (parseInt(this.pagination.current, 10) - 1) * this.pagination.perPage +
        this.applicants.length
      );
    },
  },
  methods: {
    ...mapActions([
      actions.applicant.LOAD_APPLICANTS,
      actions.applicant.LOAD_SCOUT_APPLICANTS,
      'loadMenuConfigurations',
      'loadReviewLists',
    ]),
    ...mapMutations([
      mutations.applicant.SET_APPLICANTS,
      mutations.applicant.CHANGE_SORT_COLUMN,
      mutations.applicant.CHANGE_SEARCH_PARAMS,
      'setScoutSearchParams',
      'setCurrentPageApplicants',
      'setApplicantCounts',
      'setPage',
      'setChildJobModel',
      'setMainJobModel',
      'setEnglishSkillModel',
      'setStatusModel',
      'setCompanyModel',
      'mutateApplicantsAfterMultipleStatus',
      'updateMainJobModel',
      'setColorModel',
      'setReviewListModel',
      'mutateApplicantsAfterMultipleReviewList',
      'mutateApplicantsAfterMultipleColor',
      'setCheckAll',
      'setReloadApplicants',
      'setLoading',
      'setScoutTypeModel',
      'setResetCheckAll',
      'setResetApplicantIds',
      'setPagination',
    ]),
    overflow() {
      this.overflowState = 1;
      // Sync temp model with actual selected value when dropdown opens
      this.tempStatusModel = [...this.getStatusModel];
    },
    applyStatusFilters() {
      this.setStatusModel([...this.tempStatusModel]);
      if (this.$refs.statusDropdown && typeof this.$refs.statusDropdown.hide === 'function') {
        this.$refs.statusDropdown.hide();
      }
      this.search();
    },
    resetStatusSelection() {
      // Reset temp selection to current actual selection
      this.tempStatusModel = [...this.getStatusModel];
    },
    checkAll() {
      this.setCheckAll(!this.isCheckAll);
    },
    // isCheckedJobseeker(id) {
    //   return this.jobseekerIds.includes(id);
    // },
    // isCheckedApplicants(){
    //   return this.jobseekerIds.length?true:false;
    // },
    checkUncheckJobseeker(id) {
      const index = this.jobseekerIds.indexOf(id);
      if (index > -1) {
        this.jobseekerIds.splice(index, 1);
      } else {
        this.jobseekerIds.push(id);
      }
    },
    sorting(key) {
      let column = '';
      if (this.sortKey !== null) {
        if (this.sortKey === key) {
          if (this.asc) {
            column = key;
            this.asc = false;
          } else {
            column = `-${key}`;
            this.asc = true;
          }
        } else {
          column = `-${key}`;
          this.asc = true;
        }
      } else {
        column = `-${key}`;
        this.asc = true;
      }
      this.sortKey = key;
      this[mutations.applicant.CHANGE_SORT_COLUMN](column);
      // this.setPage(1);
    },
    async load(params = {}) {
      try {
        this.setLoading(true);
        this.errors = [];
        if (this.isReviewer || this.isAdmin) {
          this.loadReviewLists();
        }

        const { data } = await this[actions.applicant.LOAD_SCOUT_APPLICANTS](params);

        this[mutations.applicant.SET_APPLICANTS](data.data);

        this.setResetCheckAll();

        this.setResetApplicantIds();

        this.setCurrentPageApplicants(data.data);

        this.showEmptyMessage = this.applicants.length === 0;

        this.setPagination(data.meta.pagination || {});
        // this.pagination = data.meta.pagination || {};
        this.showcount();
      } catch (error) {
        console.log(error);
        // this.parseErrorResponse(response);
      } finally {
        // this.loading = false;
        this.setLoading(false);
        this.setReloadApplicants(false);
      }
    },
    buildParams(page = null) {
      const params = {};
      if (page) params.page = page;
      // if (this.activeCategory) params.category = this.activeCategory;
      if (this.pagination.perPage == 50) params.rowPerPage = 50;
      if (this.favoritesOnly) params.favorites = 1;
      if (this.scoutOnly) params.isScoutOnly = true;
      if (this.interviewsOnly) params.interviews = 1;
      if (this.searchParams && Object.keys(this.searchParams).length > 0) {
        Object.assign(params, this.searchParams);
      }

      if (this.sortBy) params.sort = this.sortBy;
      params.isNewPanel = true;
      // if(!this.isReviewer) this.setStatusModel(['社内確認待bち']);
      // console.log(params);
      return params;
    },
    changePage(page) {
      this.setPage(page);
      // this.load(this.buildParams(page));
    },
    rowNumber(index) {
      return (
        index +
        1 +
        (parseInt(this.pagination.current, 10) - 1) * this.pagination.perPage
      );
    },
    showcount() {
      this.setApplicantCounts({
        total: this.pagination.total,
        from: this.from,
        to: this.to,
        perPage: this.pagination.perPage,
      });
    },
    isChecked(id) {
      if (this.mainJobModel.indexOf(id) !== -1) return true;
      return false;
    },
    search() {
      const params = {};
      Object.assign(params, this.searchParams);
      params.childOccupations = this.childJobModel;
      params.englishSkills = this.englishSkillModel;
      params.status = this.statusModel;
      params.regcompany = this.companyModel;
      // params.client_color = this.colorModel;
      params.scoutType = this.scoutTypeModel;
      if (params.childOccupations.length === 0) delete params.childOccupations;
      if (params.englishSkills.length === 0) delete params.englishSkills;
      this.setScoutSearchParams(params);
      this.overflowState = 0;
    },
  },
  watch: {
    reloadApplicants: function() {
      if (this.page === 1) {
        this.load(this.buildParams(1));
      } else {
        this.setPage(1);
      }
    },
    scoutedBy: function() {
      if (this.page === 1) this.load(this.buildParams(1));
      else this.setPage(1);
    },
    // applicantStatusToFilter: function() {
    //   if (this.page === 1) this.load(this.buildParams(1));
    //   else this.setPage(1);
    // },
    // eslint-disable-next-line
    activeCategory(categories) {
      if (this.page === 1) this.load(this.buildParams(1));
      else this.setPage(1);
    },
    // eslint-disable-next-line
    favoritesOnly: function() {
      if (this.page === 1) this.load(this.buildParams(1));
      else this.setPage(1);
    },
    // eslint-disable-next-line
    scoutOnly: function() {
      if (this.page === 1) this.load(this.buildParams(1));
      else this.setPage(1);
    },
    interviewsOnly: function() {
      if (this.page === 1) this.load(this.buildParams(1));
      else this.setPage(1);
    },
    // eslint-disable-next-line
    searchParams: function() {
      if (this.page === 1) this.load(this.buildParams(1));
      else this.setPage(1);
    },
    // eslint-disable-next-line
    page: function(currentPage) {
      this.load(this.buildParams(currentPage));
    },
    // eslint-disable-next-line
    sortBy: function(value) {
      if (this.page === 1) this.load(this.buildParams(1));
      else this.setPage(1);
    },

    // mainJobModel(mainJobs) {
    //   this.updateMainJobModel({mainJobs});
    // },
  },
};
</script>
<style scoped>
>>> .th-dropdown .btn {
  color: #026c6c !important;
  font-size: 14px !important;
}
.client-listing-detail table th a {
  color: #036d6c;
  font-size: 12px;
  text-decoration: none !important;
}

.color-th >>> .btn {
  min-width: 10px !important;
}

.color-th >>> .dropdown-menu {
  min-width: 150px;
}
.arrow-link i {
  color: #d0c2c2;
}
.arrow-link i.active {
  color: #036d6c;
}
.reviewer {
  background: none !important;
  color: #036d6c;
  border: none !important;
  font-size: 12px;
  font-weight: 600;
  padding: 5px 0 5px 0;
}
.reviewer:hover {
  background: none !important;
  color: #036d6c !important;
}
.th-dropdown-text {
  display: inline-block;
  min-width: 180px; /* or your desired width */
}

.dropdown-separator {
  border-top: 1px solid #e6e8ec;
  margin: 10px 0;
}

.dropdown-footer {
  display: flex;
  justify-content: center;
  padding: 3px 0 1px 0;
}

.ok-button {
  background-color: #62a4fd !important;
  border-color: #62a4fd !important;
  padding: 3px 18px;
  font-size: 13px;
  border-radius: 4px;
}

.ok-button:hover {
  background-color: #4a8ee4 !important;
  border-color: #4a8ee4 !important;
}

tbody tr {
  cursor: pointer;
  border: 2px;
}
th.arrow-link:hover {
  cursor: pointer;
  padding: 5px 7px !important;
}

.table-responsive {
  overflow-x: visible;
}
</style>
